/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_C3Inputs */

const en_guide_json_vs_yaml_xml_c3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choosing one for config, for the wire, for documents`)
};

const ko_guide_json_vs_yaml_xml_c3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정용, 전송용, 문서용으로 무엇을 고를지`)
};

const ja_guide_json_vs_yaml_xml_c3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定用、転送用、文書用に何を選ぶか`)
};

/**
* | output |
* | --- |
* | "Choosing one for config, for the wire, for documents" |
*
* @param {Guide_Json_Vs_Yaml_Xml_C3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_c3 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_C3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_C3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_c3(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_c3(inputs)
	return ja_guide_json_vs_yaml_xml_c3(inputs)
});